import { forwardRef, type InputHTMLAttributes } from 'react';
import { ImageComponent } from '@/components/Image';
import {
  InputStructure,
  type InputStructureProps,
} from '../structures/InputStructure';

import { ScInput } from './styled';

export type InputBlockProps = InputHTMLAttributes<HTMLInputElement> &
  InputStructureProps & {
    icon?: string;
    approved?: boolean;
  };

export const InputBlock = forwardRef<HTMLInputElement, InputBlockProps>(
  ({ error, hideErrorMessage, disabled, icon, prefix, ...rest }, ref) => (
    <InputStructure
      disabled={disabled}
      error={error}
      hideErrorMessage={hideErrorMessage}
      {...rest}
    >
      {prefix && <div className="prefix">{prefix}</div>}
      {icon && (
        <ImageComponent
          alt="input icon"
          className="input-icon"
          height={24}
          src={icon}
          width={24}
        />
      )}
      <ScInput
        {...rest}
        disabled={disabled}
        error={!!error}
        icon={!!icon}
        prefix={prefix}
        ref={ref}
      />
    </InputStructure>
  )
);
